module.exports = __webpack_public_path__ + "static/media/part-5-2.fb22c7d4.webp";